import * as React from "react";
import { createRoot } from "react-dom/client";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";

import { AuthProvider } from "./contexts/AuthContext";
import { ToastProvider } from "./contexts/ToastProvider";
import App from "./app";
import {
  getStoredCitationMapping,
  clearCitationMapping,
  validateAndCleanCitations
} from "./utils/documentProperties";

// Expose citation utilities globally for console access during debugging (dev builds only)
if (process.env.NODE_ENV !== "production") {
  window.citeMedDebug = {
    getCitations: () => getStoredCitationMapping().then(m => { console.log(m); return m; }),
    clearCitations: () => clearCitationMapping().then(() => console.log("Citations cleared!")),
    validateCitations: () => validateAndCleanCitations().then(r => { console.log(r); return r; })
  };
}


const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady((info) => {
  if (info.host === Office.HostType.Word) {
    root?.render(
      <FluentProvider theme={webLightTheme}>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </FluentProvider>
    );
  }
});

if (module.hot) {
  module.hot.accept("./app", () => {
    const NextApp = require("./app").default;
    root?.render(NextApp);
  });
}
